import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';
import type { SearchQueryInterface } from '@zaoblako/shared/common/dtos/search-query.dto';
import type { BankFindInterface } from '@zaoblako/shared/modules/catalog/dtos/bank/bank-find.dto';

@Injectable({
  providedIn: 'root'
})
export class BankService extends BaseService {
  protected baseUrl = '/basis/catalog/bank';

  public search(queryParams: SearchQueryInterface): Observable<BankFindInterface[]> {
    return this.http.get<BankFindInterface[]>(`${this.baseUrl}/search`, { params: this.objectToHttpParams(queryParams) });
  }
}
